import type { RouteRecordRaw, Router } from 'vue-router'

const BuyContractRoutes: RouteRecordRaw = {
  path: '/contract/financial/buy',
  name: 'BuyModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'BuyMainRoute',
      component: () => import('./views/BuyView.vue'),
      meta: {
        title: 'buy.buyContract',
      },
    },
    {
      path: 'create',
      name: 'BuyCreateRoute',
      component: () => import('./views/BuyUpsertView.vue'),
      meta: {
        title: 'buy.createBuyContract',
        pageHasBack: true,
      },
    },
    {
      path: 'edit/:buyId',
      name: 'BuyEditRoute',
      component: () => import('./views/BuyUpsertView.vue'),
      meta: {
        title: 'buy.editBuyContract',
        pageHasBack: true,
      },
    },
    {
      path: 'view/:buyId',
      name: 'ViewBuyRoute',
      component: () => import('./views/SingleBuyView.vue'),
      meta: {
        title: 'buy.ViewBuy',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(BuyContractRoutes)
}
